import { DecimalNumberFormatValueConverter } from './decimal-number-format';
import { LocalDateFormatValueConverter } from './local-date-format';
import { ShortTimeFormatValueConverter } from './short-time-format';
import { TimeFormatValueConverter } from './time-format';

export const ConverterRegistrations = [
  DecimalNumberFormatValueConverter,
  LocalDateFormatValueConverter,
  ShortTimeFormatValueConverter,
  TimeFormatValueConverter,
];
